export class ActivityPricing {
  discovery: number;
  influencers: number;
  campaigns: number;
  profiles: number;
  exportReport: number;
  monitoring: number;

  constructor() {
    this.discovery = 0;
    this.influencers = 0;
    this.campaigns = 0;
    this.profiles = 0;
    this.exportReport = 0;
    this.monitoring = 0;
  }
}



// WEBPACK FOOTER //
// ./src/models/Billing/activity-pricing.ts